import { type Leaderboard } from "@client/content/modules/Leaderboard/types";
import Button from "@client/controls/Button/component";
import classNames from "classnames";
import * as React from "react";
import LearnMoreModal from "./LearnMoreModal/component";
import Item from "./Reward/Item/component";
import Reward from "./Reward/component";

import { useI18n } from "@common/hooks/i18n";
import "./style.less";

export type MapProps = {
  current?: Leaderboard.Item | null;
  hasMore: boolean;
  isLoading: boolean;
  isMobile: boolean;
  referring?: Leaderboard.Item | null;
  rewards: Leaderboard.Reward[];
  topTitle?: string | null;
  type: Leaderboard.ItemType;
  items: Leaderboard.Item[];
  onClickItem?: (item: Leaderboard.Item) => void;
};

export interface ActionProps {
  onLoadNextPage: () => void;
}

const OTHER_REWARD_ID = "OTHER";
export default (props: ActionProps & MapProps) => {
  const i18n = useI18n();

  const [currentReward, setCurrentReward] = React.useState<Leaderboard.Reward | null>(null);

  const rewards = React.useMemo(() => {
    const finalRewards = props.rewards.slice();

    if (props.items.some((x) => !x.rewardId)) {
      finalRewards.push({
        id: OTHER_REWARD_ID,
        description: "",
        name: i18n.otherContestants,
        sortOrder: 100000
      });
    }

    return finalRewards;
  }, [props.rewards, props.items]);

  return (
    <div className="network_leaderboard">
      <table className={classNames("rewards", { mobile: props.isMobile })}>
        <tbody>
          {props.current || props.referring ? (
            <Item
              item={props.current || props.referring!}
              isMobile={props.isMobile}
              onClick={props.onClickItem}
              current={props.current}
              referring={props.referring}
            />
          ) : null}
          {props.current || props.referring ? (
            <tr className="sep">
              <td colSpan={props.isMobile ? 3 : 5} />
            </tr>
          ) : null}
          <tr className="header">
            <td>{i18n.position}</td>
            <td className="name">
              <div className="single-line-ellipsis">{i18n.name}</div>
            </td>
            {!props.isMobile && <td>{i18n.country}</td>}
            <td>{props.type === "incentive" ? i18n.points : i18n.votes}</td>
            {!props.isMobile && <td></td>}
          </tr>
          {rewards.map((x, i) => {
            const items = props.items.filter((y) => (!y.rewardId && x.id === OTHER_REWARD_ID) || y.rewardId === x.id);
            return (
              <Reward
                key={x.id}
                learnMore={() => setCurrentReward(x)}
                index={i}
                isMobile={props.isMobile}
                items={items}
                reward={x}
                onClickItem={props.onClickItem}
                current={props.current}
                referring={props.referring}
              />
            );
          })}
        </tbody>
      </table>

      {props.hasMore && (
        <Button className="btn-light load_more" isBusy={props.isLoading} onClick={props.onLoadNextPage}>
          {i18n.loadMoreChallengers}
        </Button>
      )}

      <LearnMoreModal
        onClose={() => setCurrentReward(null)}
        isVisible={!!currentReward}
        title={currentReward?.name ?? ""}
        description={currentReward?.description ?? ""}
      />
    </div>
  );
};
